/**
 * The printable action cards Scan Samples understands. Their payloads are on labels already in use, so they
 * never change; only the wording printed under the code can.
 */

/**
 * @typedef {Object} ActionCard
 * @property {string} Hash
 * @property {string} Payload - What the QR code holds.
 * @property {string} Label - Button text, e.g. `Print "Move All" Code`.
 * @property {string} Footer - Printed under the code.
 * @property {string} Description - What scanning it does.
 * @property {string} Icon - Font Awesome class.
 */

/** @type {Array<ActionCard>} */
const ACTION_CARDS =
[
	{ Hash: 'collect', Payload: 'action/open/cart', Label: 'Print "Move Together" Code', Footer: 'Scan Samples: Move Together', Description: 'Opens Scan Samples and collects scanned samples, to move them together with Move all.', Icon: 'fa-cart-shopping' },
	{ Hash: 'save-each', Payload: 'action/receive/start', Label: 'Print "Save Each Scan" Code', Footer: 'Scan Samples: Save Each Scan', Description: 'Opens Scan Samples and saves each scanned sample to the location straight away.', Icon: 'fa-inbox-in' },
	{ Hash: 'submit', Payload: 'action/submit', Label: 'Print "Move All" Code', Footer: 'Move All / Finish', Description: 'Moves the collected samples to the location (Move all), or finishes a list of saved scans.', Icon: 'fa-cart-shopping-fast' },
	{ Hash: 'clear', Payload: 'action/clear', Label: 'Print "Clear" Code', Footer: 'Clear Scanned Samples', Description: 'Clears the scanned samples from the list.', Icon: 'fa-cart-circle-xmark' },
];

module.exports =
{
	ACTION_CARDS,
};
